import React from "react";

import { Icon } from "@cobasi/ds-icons";

import type {
  FilterLettersProps,
  LowercaseLetter
} from "./filterLetters.types";

import { alphabet } from "@/utils/tsx/alphabet";

import s from "./filterLetters.module.scss";

const FilterLetters = ({
  avaibleLetters,
  onClick,
  disabled = false
}: FilterLettersProps) => {
  return (
    <div className={s.wrapper}>
      {alphabet.map(({ letter, icon }) => {
        const isButtonDisabled =
          disabled ||
          (avaibleLetters &&
            !avaibleLetters?.includes(letter as LowercaseLetter));
        return (
          <button
            className={s["letters-button"]}
            key={letter}
            disabled={isButtonDisabled}
            onClick={() => onClick(letter as LowercaseLetter)}
            type="button"
            aria-label="Filtrar por letra"
            data-testid={`letter-${letter}`}
          >
            <Icon icon={icon} width="1.8rem" height="1.8rem" />
          </button>
        );
      })}
    </div>
  );
};

export default FilterLetters;
